module.exports = __webpack_public_path__ + "static/img/donie-blindfolded.47b164a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/donie-blindfolded.svg
// module id = vSId
// module chunks = 1